// @flow

import { connect } from 'react-redux';
import { fetchContentful } from 'client/actions/contentful';
import FindWorkPage from './findWorkPage';

const mapStateToProps: Object = state => ({
  contentfulData: state.contentfulData,
  translations: state.translations,
});

export default connect(mapStateToProps, { fetchContentful })(FindWorkPage);
